import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components/native';
import { View, Switch, StyleSheet } from 'react-native';
import _ from 'lodash';
import { Heading4, BasicText as Text, ModalSubmitButton as SubmitButton } from '../../Styles';
import { Bound } from 'opidcore';
import { InputText, OpidFlatList } from '../../core';
import WasteBrand from '../../../WasteTheme';
import Util from '../../core/Util';

const MoreInformationStyles = StyleSheet.create({
    switch: {
        display: "flex",
        flexDirection: "row",
        marginTop: 5,
        marginBottom: 5,
        height: 30,
        alignItems: "center"
    }
})

const MoreInformationOption = ({item, updateSelection = (item, enabled) => console.log("TODO"), defaultEnabled = false}) => {
    const [isEnabled, setIsEnabled] = useState(false);

    useEffect(()=>{
        setIsEnabled(defaultEnabled);
    }, [defaultEnabled]);

    const toggleSwitch = (newValue)=>{
        updateSelection(item, newValue);
        setIsEnabled(newValue);
    };

    return <View style={MoreInformationStyles.switch}>
        <Switch
            trackColor={{ false: "#767577", true: "#81b0ff" }}
            thumbColor="#f4f3f4"
            activeThumbColor="#003fa8"
            onValueChange={()=>toggleSwitch(!isEnabled)}
            value={isEnabled}
        />
        <Text style={{marginLeft: 10}}>{item.label}</Text>
    </View>;
}

const MoreInformation = ({site, allPrograms = [], defaultSelected = []}) =>{
    const [selected, setSelected] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const boundRef = useRef({notes: undefined});

    useEffect(()=>{
        _.forEach(defaultSelected, (s)=>{
            updateSelection(s, true);
        });
    }, [defaultSelected]);

    const updateSelection = (item, enabled) =>{
        let newSelected = {...selected};
        if( enabled == false){
            delete newSelected[item.label];
        } else {
            newSelected[item.label] = item;
        }

        setSelected(newSelected);
    }

    const submit = () => {        
        fetch(Util.getHost() + "/api/v1/portal/requestMoreInformation", {
            method: "POST",
            body: JSON.stringify({
                requestedInfo: {
                    client: site.client_id,
                    site: site.site_id,
                    selectedServices: selected,
                    notes: boundRef.current.notes
                }
            })
        }).then((r)=>{
            setSubmitted(true);
        });
    };
    
    if(submitted == true){
        return <View>
            <Heading4>Request More Information</Heading4>
            <Text>Request submitted. Look for an email from Waste Solutions with the attached information.</Text>
        </View>;
    }

    return <View>
        <Heading4>Request More Information</Heading4>
        <OpidFlatList
            data={allPrograms}
            renderItem={(item)=><MoreInformationOption item={item} updateSelection={updateSelection} defaultEnabled={selected[item.label] != undefined}/>}
            keyExtractor={item => item.icon}
        />
        <Bound to={boundRef.current}>
            <InputText field="notes" label="Notes" multiline={true} style={{flexBasis: 70, minWidth: 300}}/>
        </Bound>
        <SubmitButton onPress={submit} theme={WasteBrand}>Submit</SubmitButton>
    </View>;
}

export default MoreInformation;